import {
  arrayOf,
  bool,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import request from "../../services/request";
import { formatNullData } from "../../utils";
import ActionButtons from "../action-buttons";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
} from "../action-buttons/ActionButtonGenerator";
import EditTable from "../table/EditTable";
import FileSaver from "file-saver";
class EditListComponent extends Component {
  constructor(props) {
    super(props);

    this.getData = this.getData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSingleRowSelect = this.onSingleRowSelect.bind(this);
    this.onAllRowsSelect = this.onAllRowsSelect.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onAllEditClicked = this.onAllEditClicked.bind(this);
    this.onDownloadExcelClicked = this.onDownloadExcelClicked.bind(this);

    const eventsObjects = {
      [ABT.UPDATE_ALL_ITEM.name]: this.onAllEditClicked,
      [ABT.EXCEL_EXPORT.name]: this.onDownloadExcelClicked,
      // [ABT.EDIT.name]: this.onEditClicked,
      // [ABT.DELETE.name]: this.onDeleteClicked,
      // [ABT.ACTIVE.name]: this.onChangeStatusClicked,
      // [ABT.PASSIVE.name]: this.onChangeStatusClicked,
      // [ABT.DOWNLOAD.name]: this.onDownloadClicked,
      // [ABT.EXCEL_EXPORT.name]: this.onDownloadExcelClicked,
      // [ABT.PREVIEW.name]: this.onPreviewClicked,
      // [ABT.GOTOPAGE.name]: this.onGoToPageClicked,
      // [ABT.GOTOPAGETWO.name]: this.onGoToPageClicked,
    };

    this.state = {
      language: props.i18n && props.i18n.language,
      pageIndex: 1,
      pageSize: props.defaultPageSize ? props.defaultPageSize : 10,
      totalSize: 0,
      data: [],
      columns: props.columns.map((column) => {
        column.formatter = column.formatter ? column.formatter : formatNullData;
        column.onSort = this.onSortChange;
        column.attrs = column.attrs
          ? column.attrs
          : function callback(cell) {
              return { title: cell };
            };
        column.headerAttrs = function callback(column) {
          return { title: column.text };
        };
        return column;
      }),
      actionButtons: props.actionButtonsObject.generator(
        props.actionButtonsObject,
        eventsObjects
      ),
      selectedRows: [],
      onSortChangeFunc: this.onSortChange,
    };
  }

  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    let x = ABT;
    if (prevProps.refreshList !== this.props.refreshList) {
      this.getData({ pageIndex: 1 });
      if (document.getElementsByClassName("page-link") && document.getElementsByClassName("page-link").length > 0) {
        document.getElementsByClassName("page-link")[0].click();
      }
    }

    if (this.state.language !== this.props.i18n.language) {
      this.getData();
      this.setState({
        language: this.props.i18n.language,
      });
    }

    if (prevProps.columns != this.props.columns) {
      this.setState({
        columns: this.props.columns.map((column) => {
          column.formatter = column.formatter
            ? column.formatter
            : formatNullData;
          column.onSort = this.onSortChange;
          column.attrs = column.attrs
            ? column.attrs
            : function callback(cell) {
                return { title: cell };
              };
          column.headerAttrs = function callback(column) {
            return { title: column.text };
          };
          return column;
        }),
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      data: [],
      totalSize: 0,
      selectedRows: null,
    });
  }

  getData(params = {}) {
    const { customBody } = this.props;
    const {
      pageIndex = this.state.pageIndex,
      pageSize = this.state.pageSize,
      sortProps = this.state.sortProps,
    } = params;

    let queryBody = {
      sortOrder: "DESC",
      pageIndex: pageIndex - 1,
      pageSize: pageSize,
      filters: [],
    };

    if (sortProps) {
      queryBody.sortOrder = sortProps.order.toUpperCase();
      queryBody.sortColumn = sortProps.field;
    } else if (customBody.sortColumn) {
      queryBody.sortOrder = customBody.sortOrder;
      queryBody.sortColumn = customBody.sortColumn;
    }

    if (customBody.filters) {
      queryBody.filters = queryBody.filters.concat(customBody.filters);
    }

    if (customBody.id) {
      queryBody.id = customBody.id;
    }

    if (customBody.userId) {
      queryBody.userId = customBody.userId;
    }

    if (customBody.talepTurId) {
      queryBody.talepTurId = customBody.talepTurId;
    }

    const { endpoint } = this.props;

    request({
      url: endpoint,
      method: "POST",
      data: {
        body: queryBody,
      },
    }).then((res) => {
      if (res.responseStatus === "SUCCESS") {
        this.setTableData(res);
      }
    });
  }

  onSortChange(field, order) {
    const param = {
      sortProps: {
        field: field,
        order: order,
      },
    };

    this.setState(param);
    this.getData(param);
  }

  setTableData(response) {
    const { mapDataBeforeList, mapNativeDataBeforeList } = this.props;
    let newResponse = response.body
      ? response.body.tableData
        ? response.body.tableData
        : response.body
      : [];

    if (mapNativeDataBeforeList) {
      newResponse = mapNativeDataBeforeList(newResponse);
    }

    if (mapDataBeforeList) {
      newResponse = newResponse.map(mapDataBeforeList);
    }

    this.setState({
      data: newResponse,
      totalSize: response.body ? response.body.totalElements : 0,
    });
  }

  onPageChange(pageIndex, pageSize) {
    if (
      pageIndex !== this.state.pageIndex ||
      pageSize !== this.state.pageSize
    ) {
      this.getData({
        pageIndex: pageIndex,
        pageSize: pageSize,
      });

      this.setState({ pageIndex, pageSize });
    }
  }

  onRowSelect(row, isSelected) {
    const { selectedRows } = this.state;
    const { keyField, setSelectedRow } = this.props;

    let newArray = [];

    if (isSelected) {
      if (selectedRows.every((x) => x[keyField] !== row[keyField])) {
        newArray = JSON.parse(JSON.stringify(selectedRows));
        newArray.push(row);
      }
    } else {
      if (selectedRows.some((x) => x[keyField] === row[keyField])) {
        newArray = selectedRows.filter((x) => x[keyField] !== row[keyField]);
      }
    }

    if (setSelectedRow) {
      setSelectedRow(newArray);
    }

    this.setState({ selectedRows: newArray });
  }

  onSingleRowSelect(row, isSelected) {
    const { selectedRows } = this.state;
    const { keyField } = this.props;
    let newArray = [];

    if (isSelected) {
      newArray.push(row);
      this.setState({ selectedRows: [] });
    } else {
      if (selectedRows.some((x) => x[keyField] === row[keyField])) {
        newArray = selectedRows.filter((x) => x[keyField] !== row[keyField]);
      }
    }
    this.setState({ selectedRows: newArray });
  }

  onAllRowsSelect(rows, isSelected) {
    let newArray = [];

    if (isSelected) {
      newArray = JSON.parse(JSON.stringify(this.state.data));
    }
    const { setSelectedRow } = this.props;
    if (setSelectedRow) {
      setSelectedRow(newArray);
    }
    this.setState({ selectedRows: newArray });
  }

  onAllEditClicked(buttonObj) {
    const { data } = this.state;

    request({
      url: buttonObj.requestTo,
      method: "POST",
      data: {
        body: { tableData: data },
      },
    }).then((res) => {
      if (res.responseStatus === "SUCCESS") {
        this.getData();
      }
    });
  }

  onDownloadExcelClicked(buttonObj) {
    const { customBody } = this.props;
    let excelName = "Excel";
    request({
      url: buttonObj.requestTo,
      method: "POST",
      data: {
        body: {
          sortOrder: "DESC",
          pageIndex: 0,
          pageSize: 10000,
          filters: customBody.filters || []
        },
      },
    }).then((res) => {
      var buffer = new Buffer(res.data, "base64");
      var blob = new Blob([buffer], { type: res.headers["content-type"] });
      excelName=res.headers["filename"];
      var fileName = new Buffer(excelName, 'base64')
      FileSaver.saveAs(blob, fileName + ".xlsx");
    });
  }

  render() {
    const {
      data,
      columns,
      pageIndex,
      pageSize,
      totalSize,
      actionButtons,
      selectedRows,
    } = this.state;
    const {
      keyField,
      development,
      basicData,
      isMultiSelect,
      expandable,
      expandComponent,
      hideSelection,
      expandItem,
      visiblePagination,
      visibleRowSelect,
      specificKeyField,
      filters,
      totalDay,
      hideBorder,
    } = this.props;

    return (
      <div className={hideBorder ? "" : "border rounded mt-3 p-3"}>
        {actionButtons && (
          <>
            <ActionButtons
              ref="ActionButtons"
              buttons={actionButtons}
              selectedRows={selectedRows}
              keyField={keyField}
              refreshList={this.getData}
            />
          </>
        )}
        {totalDay && (
          <span className="float-right text-black">
            Toplam Süre: {totalDay}
          </span>
        )}
        <EditTable
          keyField={specificKeyField ? specificKeyField : keyField}
          actionButtonsRef={this.refs.ActionButtons}
          data={data}
          columns={columns}
          page={pageIndex}
          sizePerPage={pageSize}
          totalSize={totalSize}
          onPageChange={this.onPageChange}
          rowClassFormat={this.rowClassFormat}
          onSelect={this.onRowSelect}
          onSingleSelect={this.onSingleRowSelect}
          onSelectAll={this.onAllRowsSelect}
          selectedRows={selectedRows}
          isMultiSelect={!!isMultiSelect}
          expandable={expandable}
          expandComponent={expandComponent}
          hideSelection={hideSelection}
          expandItem={expandItem}
          pagination={visiblePagination}
          selectable={visibleRowSelect}
        />
      </div>
    );
  }
}

export default withRouter(withTranslation()(EditListComponent));

EditListComponent.propTypes = {
  actionButtonsObject: shape({
    actions: arrayOf(object),
    generator: func,
  }),
  keyField: string.isRequired,
  entityName: string.isRequired,
  columns: arrayOf(object).isRequired,
  endpoint: string.isRequired,
  mapDataBeforeList: func,
  mapNativeDataBeforeList: func,
  reportSource: string,
  exportExcelSource: string,
  httpActions: object,
  history: object,
  isMultiSelect: bool,
  permBase: object,
  user: object,
  hideSelection: bool,
  expandItem: string,
  customBody: shape({
    sortOrder: string,
    sortColumn: string,
    filters: arrayOf(
      shape({
        fieldName: string,
        value: oneOfType([string, bool, number]),
        oper: string,
      })
    ),
  }),
};

EditListComponent.defaultProps = {
  actionButtonsObject: {
    actions: [],
    generator: DefaultActionButtonGenerator,
  },
  keyField: "id",
  customBody: {},
  isMultiSelect: false,
  entityName: "",
  endpoint: "",
};
